// extracted by mini-css-extract-plugin
module.exports = {"home":"Anmeldung_home__2zpb5"};